import { Helmet } from "react-helmet-async";
import { Body, BodyHeading, BodyContent } from "@thrivetribe/mvf.ui.organisms.body";
import { PageIntro } from "ui/atoms/PageIntro/PageIntro";
import { ArticleCard, ArticleCardProps } from "@thrivetribe/mvf.ui.molecules.article-card";
import { ImageCard } from "@thrivetribe/mvf.ui.molecules.image-card";
import { ArticleListing } from "ui/molecules/ArticleListing";
import { ImagesUrl } from "configs/EnvironmentConfig";
import "./UsefulExtras.scss";

const cards: ArticleCardProps[] = [
  {
    title: "MAN v FAT x JAAQ",
    description:
      "Take advantage of this amazing on-demand digital mental health and wellbeing platform you can use anytime, anywhere and it's safe and anonymous, too.",
    imgUrl: `${ImagesUrl}/JAAQ.jpg`,
    imgTitle: "MAN v FAT x JAAQ",
    onClick: () => {
      window.scroll(0, 0);
      window.open("https://manvfat.jaaq.org/", "_blank");
    },
  },
  {
    title: "British Heart Foundation",
    description:
      "Find out more about heart conditions, how to boost your heart health, or where to find support and guidance.",
    imgUrl: `${ImagesUrl}/bhf.webp`,
    imgTitle: "British Heart Foundation",
    onClick: () => {
      window.scroll(0, 0);
      window.open("https://www.bhf.org.uk/", "_blank");
    },
  },
];

export const UsefulExtras = (): JSX.Element => {
  return (
    <Body className="useful-extras">
      <Helmet>
        <title>Useful extras - MAN v FAT</title>
      </Helmet>
      <BodyHeading>
        <h1>Useful Extras</h1>
      </BodyHeading>
      <BodyContent>
        <PageIntro>
          Don't just lose weight, improve your overall health and wellbeing too with bonus articles and help from our
          partners.
        </PageIntro>

        <section>
          <h2>All part of your membership</h2>
          <div className="useful-extras__cards">
            {cards.map((card, index) => (
              <div className="useful-extras__card" key={index}>
                <ArticleCard
                  title={card.title}
                  description={card.description}
                  imgUrl={card.imgUrl}
                  imgTitle={card.imgTitle}
                  ctaText={"Find out more"}
                  onClick={card.onClick}
                />
              </div>
            ))}
            <ImageCard
              backgroundImage={`${ImagesUrl}/macron-store-background.webp`}
              link="https://club.hgsportswear.co.uk/man-v-fat-player"
              logoImage={`${ImagesUrl}/hope-glory-logo.webp`}
              logoImageAlt="MAN v FAT Store | Hope & Glory Store"
              text="Want to add a MAN v FAT Football shirt to your kit? Shop the MAN v FAT Football Store."
              ctaText="MAN v FAT Store"
            />
          </div>
        </section>

        <ArticleListing
          tagType="pillarTags"
          tags={["Sleep", "Alcohol", "Mind"]}
          heading={<h2>Hot off the press: Wellbeing, Sleep & Alcohol</h2>}
        />
      </BodyContent>
    </Body>
  );
};
